import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // 验证必填字段
    if (!formData.name || !formData.email || !formData.message) {
      alert('請填寫所有必填欄位');
      return;
    }

    // 验证邮箱格式
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('請輸入有效的電郵地址');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6p6htl39lnhn4hh1ksg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* 面包屑导航 */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-gray-600 hover:text-gray-900">首頁</Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900">聯絡我們</span>
          </div>
        </div>
      </div>

      {/* 主要内容 */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* 标题区 */}
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">聯絡我們</h1>
          <p className="text-gray-600 text-lg">有任何疑問或需要協助？歡迎隨時與我們聯絡</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-12">
          {/* 聯系表单 */}
          <div>
            <h2 className="text-2xl font-bold mb-6">發送訊息</h2>
            <form onSubmit={handleSubmit} id="contact-form" data-readdy-form className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  電郵 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  電話
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="+852 1234 5678"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                  主題
                </label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                >
                  <option value="">請選擇查詢主題</option>
                  <option value="product">產品查詢</option>
                  <option value="order">訂單查詢</option>
                  <option value="delivery">送貨查詢</option>
                  <option value="return">退換貨查詢</option>
                  <option value="vip">VIP會員查詢</option>
                  <option value="other">其他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  訊息內容 <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                  placeholder="請輸入您的訊息內容（最多500字）"
                />
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.message.length}/500
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-teal-500 text-white py-3 rounded-lg font-bold hover:bg-teal-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? '發送中...' : '發送訊息'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-checkbox-circle-line mr-2"></i>
                  訊息已成功發送！我們會盡快回覆您。
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  發送失敗，請稍後再試或直接聯絡我們。
                </div>
              )}
            </form>
          </div>

          {/* 聯系信息 */}
          <div>
            <h2 className="text-2xl font-bold mb-6">聯絡資訊</h2>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-bold mb-1">門市地址</h3>
                  <p className="text-gray-700 text-sm">九龍觀塘偉業街221號</p>
                  <p className="text-gray-700 text-sm">美德工業大廈D座10樓31室</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-bold mb-1">營業時間</h3>
                  <p className="text-gray-700 text-sm">星期一至六：11:00 - 20:00</p>
                  <p className="text-gray-700 text-sm">星期日及公眾假期：12:00 - 19:00</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-bold mb-1">電話</h3>
                  <a href="tel:+85293855368" className="text-teal-600 hover:underline text-sm cursor-pointer">
                    +852 9385 5368
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-bold mb-1">電郵</h3>
                  <a href="mailto:lamlamwholesale@gmail.com" className="text-teal-600 hover:underline text-sm cursor-pointer">
                    lamlamwholesale@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* 社交媒体 */}
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="font-bold mb-4">關注我們</h3>
              <div className="flex gap-3">
                <a 
                  href="https://www.facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a 
                  href="https://www.instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}